/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

interface Config {
    BASE: string;
    VERSION: string;
    CLIENT: 'fetch' | 'xhr';
    TOKEN: string;
}

export const OpenAPI: Config = {
    BASE: '',
    VERSION: '0.0.0',
    CLIENT: 'fetch',
    TOKEN: '',
};



// WEBPACK FOOTER //
// ./src/services/openapi/generated/core/OpenAPI.ts